import { render, staticRenderFns } from "./extra-properties-filter.component.vue?vue&type=template&id=7915b35d&"
import script from "./extra-properties-filter.component.vue?vue&type=script&lang=js&"
export * from "./extra-properties-filter.component.vue?vue&type=script&lang=js&"
import style0 from "./extra-properties-filter.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports